// extracted by mini-css-extract-plugin
export default {"toProfile":"header_toProfile__WIGnm"};